import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAlert } from "../../Services/appAlerts";
import WorkflowElement from "../../app/components/WorkflowElement";
import {
  addUpdateBprmFormHistory, formUpdateHistoryAdded,
  getFormUpdateHistoryStatus, getTaskFormSavedStatus, taskFormSaved, callFormAgent, getBprmForm
} from "../../app/store/bprmForm";
import { useUploadAppDocumentsMutation } from "../../app/store/candidateApiSlice";
import { uploadFileToBlob } from "../../Services/blobUploadService";
import { getCurrentUser } from "../../app/store/auth";
import { useRef } from "react";


const ViewForm = (props) => {
  const { workflowTask, selectedForm, handleFormShowHide,
    handleFormUpdate, allowEdit, formName = "", maxFiles } = props;

  const getResolvedFormName = () => {
    return (
      formName ||
      props.formName ||
      selectedForm?.formType ||
      selectedForm?.formName ||
      selectedForm?.name ||
      selectedForm?.title ||
      wfForm?.formType ||
      wfForm?.title ||
      wfForm?.formName ||
      workflowTask?.taskName ||
      workflowTask?.formType ||
      workflowTask?.title ||
      ""
    ).trim();
  };

  const isAchFormCheck = () => {
    const lower = getResolvedFormName().toLowerCase();
    const isId47 = Number(selectedForm?.id || wfTask?.formId || wfForm?.id) === 47;
    return (
      isId47 ||
      lower.includes("ach") ||
      lower.includes("direct deposit") ||
      lower.includes("bank") ||
      lower.includes("void")
    );
  };

  const isInsuranceFormCheck = () => {
    const lower = getResolvedFormName().toLowerCase();
    return (
      lower.includes("insurance") ||
      lower.includes("coi")
    );
  };

  const getMaxFileLimit = () => {
    if (typeof maxFiles === "number" && maxFiles > 0) {
      return maxFiles;
    }
    if (isAchFormCheck()) {
      return 2;
    }
    if (isInsuranceFormCheck()) {
      return 3;
    }
    return 3;
  };

  const getUploadButtonText = () => {
    const name = getResolvedFormName();
    const lower = name.toLowerCase();

    if (lower.includes("insurance") || lower.includes("coi")) {
      return "Upload your Certificate(s) of Insurance (COI)";
    }
    if (lower.includes("ach") || lower.includes("direct deposit") || lower.includes("bank")) {
      return "Upload Your Voided Check.";
    }
    if (name) {
      return `Upload your Certificate of ${name}`;
    }
    return "Upload your Certificate(s)";
  };

  const [wfTask, setWfTask] = useState(null);
  const [saveBtnProcessStatus, setSaveBtnProcessStatus] = useState(true);
  const [updatedStateData, setUpdatedStateData] = useState(null);

  const [showAIUpload, setShowAIUpload] = useState(false);
  const [aiFiles, setAiFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [aiNotes, setAiNotes] = useState([]);
  const [unfilledIds, setUnfilledIds] = useState([]);
  const [showSummary, setShowSummary] = useState(true);
  const [wfForm, setWfForm] = useState(null);

  const currentUser = getCurrentUser();
  const [uploadAppDocuments, { data: uploadResult, reset: resetUpload }] = useUploadAppDocumentsMutation();
  const processedUploadResultRef = useRef("");
  const [uploadedAiFiles, setUploadedAiFiles] = useState([]);

  const formUpdateHistoryStatusSelector = useSelector(getFormUpdateHistoryStatus);
  const taskFormSavedStatusSelector = useSelector(getTaskFormSavedStatus);
  const bprmFormSelector = useSelector(getBprmForm);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedForm?.id && workflowTask?.ciid)
      setWfTask({ formId: selectedForm.formId, ciid: workflowTask.ciid });
  }, [selectedForm, workflowTask]);

  useEffect(() => {
    if (bprmFormSelector.length > 0)
      setWfForm(bprmFormSelector[0]);
  }, [bprmFormSelector]);

  const handleNextTask = async (frmData) => {
    if (!(frmData instanceof FormData)) return;
    setSaveBtnProcessStatus(true);
    frmData.append("formLibrary", JSON.stringify(selectedForm));

    if (uploadedAiFiles.length > 0 && props.workflowTask) {
      let usrId = currentUser?.id;
      if (currentUser?.linkUser) usrId = currentUser.linkUser;

      const resolvedName = getResolvedFormName().toLowerCase();
      let docPrefix = "form";
      if (resolvedName.includes("insurance") || resolvedName.includes("coi")) {
        docPrefix = "insurance";
      } else if (resolvedName.includes("ach")) {
        docPrefix = "ach";
      }
      const docTypeVal = `${docPrefix}_${selectedForm?.id || ""}`;

      const data = new FormData();
      data.append("message", "Uploaded via AI AutoFill");
      data.append("workflowTask", JSON.stringify(props.workflowTask));
      data.append("userId", usrId);
      data.append("docType", docTypeVal);
      data.append(
        "files",
        JSON.stringify(
          uploadedAiFiles.map((f) => ({
            name: f.file.name,
            type: f.file.type,
            size: f.file.size,
          }))
        )
      );

      try {
        const response = await uploadAppDocuments(data).unwrap();
        const sasUrls = response?.sasUrls || [];

        if (sasUrls.length > 0) {
          await Promise.all(
            uploadedAiFiles.map((fileObj, key) => {
              if (sasUrls[key]?.uploadUrl) {
                return uploadFileToBlob(fileObj.file, sasUrls[key].uploadUrl, () => { });
              }
              return Promise.resolve();
            })
          );
        }
        resetUpload();
        setUploadedAiFiles([]);
      } catch (error) {
        console.error("Upload failed:", error);
      }
    }

    dispatch(addUpdateBprmFormHistory(frmData));
  };

  useEffect(() => {
    if (formUpdateHistoryStatusSelector && taskFormSavedStatusSelector) {
      getAlert("", "Saved Successfully", "success");
      setSaveBtnProcessStatus(false);
      dispatch(formUpdateHistoryAdded(false));
      dispatch(taskFormSaved(false));
      if (handleFormUpdate) handleFormUpdate();
      if (handleFormShowHide) handleFormShowHide("save");
    }
  }, [formUpdateHistoryStatusSelector, taskFormSavedStatusSelector, dispatch, handleFormUpdate, handleFormShowHide]);

  const processFiles = (filesList) => {
    const validFiles = Array.from(filesList).filter(file => {
      const fileName = file.name.toLowerCase();
      return (
        fileName.endsWith('.pdf') ||
        fileName.endsWith('.docx') ||
        fileName.endsWith('.doc') ||
        fileName.endsWith('.jpg') ||
        fileName.endsWith('.jpeg') ||
        fileName.endsWith('.png')
      );
    });

    if (validFiles.length < filesList.length) {
      getAlert("Invalid File Type", "Only PDF, DOCX, JPG, and PNG files are allowed.", "error");
    }

    const maxLimit = getMaxFileLimit();
    const availableSlots = Math.max(0, maxLimit - aiFiles.length);

    if (availableSlots <= 0) {
      getAlert(
        "Upload Limit Reached",
        `You can upload a maximum of ${maxLimit} ${maxLimit === 1 ? "document" : "documents"} for this form.`,
        "warning"
      );
      return;
    }

    if (validFiles.length > availableSlots) {
      getAlert(
        "Upload Limit Exceeded",
        `Only ${availableSlots} more ${availableSlots === 1 ? "document" : "documents"} can be added. Maximum allowed is ${maxLimit}.`,
        "warning"
      );
    }

    const filesToProcess = validFiles.slice(0, availableSlots);

    if (filesToProcess.length === 0) return;

    filesToProcess.forEach(file => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64Str = event.target.result.split(',')[1];
        setAiFiles(prev => [...prev, { file, base64: base64Str }]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      processFiles(e.target.files);
    }
    e.target.value = null;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files) {
      processFiles(e.dataTransfer.files);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleRemoveFile = (indexToRemove) => {
    setAiFiles(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const isAddressField = (key = "") => {
    if (!key || typeof key !== "string") return false;
    const rawKey = key.includes(".") ? key.split(".").pop() : key;
    const normalized = rawKey.toLowerCase().replace(/[^a-z0-9]/g, "");
    return (
      normalized.includes("address") ||
      normalized.includes("street") ||
      normalized.includes("city") ||
      normalized.includes("state") ||
      normalized.includes("zip") ||
      normalized.includes("postal") ||
      normalized.includes("county") ||
      normalized.includes("country")
    );
  };

  const isAchTargetField = (key = "") => {
    if (!key || typeof key !== "string") return false;
    const rawKey = key.includes(".") ? key.split(".").pop() : key;
    const normalized = rawKey.toLowerCase().replace(/[^a-z0-9]/g, "");

    // Never allow address fields as ACH targets
    if (
      normalized.includes("address") ||
      normalized.includes("street") ||
      normalized.includes("city") ||
      normalized.includes("state") ||
      normalized.includes("zip") ||
      normalized.includes("postal") ||
      normalized.includes("county") ||
      normalized.includes("country")
    ) {
      return false;
    }

    // Exclude account type, form type, or any type metadata
    if (normalized.includes("type")) return false;

    // 1. Bank Name: yourbankname, youbankname, bankname, yourbank, bank
    if (normalized.includes("bankname") || normalized === "yourbank" || normalized === "bank") {
      return true;
    }

    // 2. Routing: routing, routingnumber, routingno, routingnum
    if (normalized.includes("routing")) {
      return true;
    }

    // 3. Account Number: account, accountno, accountnumber, accountnum
    if (normalized.includes("account")) {
      return true;
    }

    return false;
  };

  const formatUnfilledFieldLabel = (id = "") => {
    if (!id) return "";
    const raw = id.includes(".") ? id.split(".").pop() : id;
    const norm = raw.toLowerCase().replace(/[^a-z0-9]/g, "");

    if (norm.includes("bankname") || norm === "yourbank" || norm === "bank") {
      return "Bank Name";
    }
    if (norm.includes("routing")) {
      return "Routing Number";
    }
    if (norm.includes("account") && !norm.includes("type")) {
      return "Account Number";
    }

    return raw
      .replace(/([A-Z])/g, " $1")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  };

  const cleanTalonicText = (text) => {
    if (typeof text !== "string") return text;
    return text.replace(/talonic/gi, "Agent");
  };

  const handleUploadDoc = async () => {
    if (aiFiles.length === 0 || !wfForm) return;

    let parsedSchema = [];
    if (wfForm.elementJson) {
      try {
        parsedSchema = JSON.parse(wfForm.elementJson);
      } catch (e) {
        console.error("Failed to parse elementJson:", e);
      }
    }

    const fieldMap = {};
    const fieldTypeMap = {};
    parsedSchema.forEach(col => {
      if (col.components) {
        col.components.forEach(comp => {
          if (comp.attributeType && comp.attributeObject) {
            const controleId = comp.attributeType.toLowerCase() + "." + comp.attributeObject;
            fieldMap[comp.attributeObject] = controleId;
            fieldTypeMap[controleId] = comp.attributeDataTypes?.type;
            if (comp.id) {
              fieldMap[comp.id] = controleId;
            }
          }
        });
      }
    });

    const resolvedFormName = getResolvedFormName().toLowerCase();

    // Check schema components for ACH indicators
    const hasAchComponents = parsedSchema.some(col =>
      col.components && col.components.some(comp => {
        const attrType = String(comp.attributeType || "").toLowerCase();
        const attrObj = String(comp.attributeObject || "").toLowerCase();
        const compId = String(comp.id || "").toLowerCase();
        return (
          attrType.includes("ach") ||
          attrObj.includes("routing") ||
          attrObj.includes("account_no") ||
          attrObj.includes("bank_name") ||
          compId.includes("routing") ||
          compId.includes("bankname") ||
          compId.includes("account")
        );
      })
    );

    // Check fieldMap for ACH indicators
    const hasAchFieldsInMap = Object.keys(fieldMap).concat(Object.values(fieldMap)).some(k => {
      const lowerK = String(k).toLowerCase();
      return (
        lowerK.includes("achinfo") ||
        lowerK.includes("routing") ||
        lowerK.includes("bank_name") ||
        lowerK.includes("account_no")
      );
    });

    // Check uploaded files
    const hasCheckFile = aiFiles.some(f => {
      const fName = String(f.file?.name || "").toLowerCase();
      return fName.includes("check") || fName.includes("void") || fName.includes("ach");
    });

    const isAchByName =
      resolvedFormName.includes("ach") ||
      resolvedFormName.includes("void") ||
      resolvedFormName.includes("check") ||
      resolvedFormName.includes("direct deposit") ||
      resolvedFormName.includes("bank");

    const isAchForm = isAchByName || hasAchComponents || hasAchFieldsInMap || (hasCheckFile && hasAchComponents);

    setIsUploading(true);
    setAiNotes([]);
    setUnfilledIds([]);

    let cumulativeMappedValues = {};
    let cumulativeNotes = [];
    let cumulativeUnfilledIds = [];

    // For ACH, filter schema sent to AI to only target ACH fields if possible
    let schemaForAgent = parsedSchema;
    if (isAchForm && parsedSchema && parsedSchema.length > 0) {
      const filtered = parsedSchema.map(col => {
        if (!col.components) return col;
        return {
          ...col,
          components: col.components.filter(comp => {
            const targetKey = comp.attributeObject || comp.id || "";
            const mappedTarget = fieldMap[targetKey] || targetKey;
            return isAchTargetField(targetKey) || isAchTargetField(mappedTarget);
          })
        };
      }).filter(col => col.components && col.components.length > 0);

      if (filtered.length > 0) {
        schemaForAgent = filtered;
      }
    }

    const agentPrompt = isAchForm
      ? "Help the user complete the ACH form by autofilling only the bank name, routing number, and account number from the voided check document. Do not autofill address or any other fields."
      : "Help the user complete task forms by autofilling fields from available documents, suggesting field values, and identifying missing inputs.";

    for (let i = 0; i < aiFiles.length; i++) {
      const currentFile = aiFiles[i];
      const fileNameLower = currentFile.file.name.toLowerCase();
      let mimeType = currentFile.file.type;
      if (!mimeType) {
        if (fileNameLower.endsWith('.pdf')) mimeType = 'application/pdf';
        else if (fileNameLower.endsWith('.png')) mimeType = 'image/png';
        else if (fileNameLower.endsWith('.jpg') || fileNameLower.endsWith('.jpeg')) mimeType = 'image/jpeg';
        else if (fileNameLower.endsWith('.docx')) mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        else if (fileNameLower.endsWith('.doc')) mimeType = 'application/msword';
        else mimeType = 'application/octet-stream';
      }

      const payload = {
        prompt: agentPrompt,
        form_schema: schemaForAgent,
        document_text: "",
        document: {
          filename: currentFile.file.name,
          mime_type: mimeType,
          content_base64: currentFile.base64
        },
        model: "gpt-4.1-mini",
        temperature: 0.2
      };

      try {
        const res = await dispatch(callFormAgent(payload));
        console.log(`Response for ${currentFile.file.name}:`, res);

        if (res) {
          if (res.fieldValues) {
            for (const [key, value] of Object.entries(res.fieldValues)) {
              const mappedKey = fieldMap[key];
              const isTargetAch = isAchTargetField(key) || (mappedKey && isAchTargetField(mappedKey));

              // If ACH form or if check document, strictly only allow bank name, account number, and routing number
              // Never autofill address fields
              if (isAchForm || hasCheckFile || hasAchComponents) {
                if (isAddressField(key) || (mappedKey && isAddressField(mappedKey))) {
                  continue;
                }
                if (!isTargetAch) {
                  continue;
                }
              }

              let correctKey = mappedKey || key;
              if (isAchForm && !mappedKey) {
                const matchingControlId = Object.values(fieldMap).find(cId => {
                  const normCId = cId.toLowerCase().replace(/[^a-z0-9]/g, "");
                  const normKey = key.toLowerCase().replace(/[^a-z0-9]/g, "");
                  if ((normKey.includes("bankname") || normKey.includes("bank")) && normCId.includes("bank")) return true;
                  if (normKey.includes("routing") && normCId.includes("routing")) return true;
                  if (normKey.includes("account") && normCId.includes("account") && !normCId.includes("type")) return true;
                  return false;
                });
                if (matchingControlId) {
                  correctKey = matchingControlId;
                }
              }

              let finalValue = value;
              if (fieldTypeMap[correctKey] === "number" && typeof value === "string") {
                finalValue = value.replace(/[^0-9.]/g, '');
              }

              cumulativeMappedValues[correctKey] = finalValue;
            }
          }
          if (res.notes && res.notes.length > 0) {
            let processedNotes = res.notes.map(note => cleanTalonicText(note));
            if (isAchForm || hasCheckFile || hasAchComponents) {
              processedNotes = processedNotes.filter(note => {
                const lower = note.toLowerCase();
                // Filter out irrelevant notes for ACH
                if (lower.includes("account type") || lower.includes("email for ach") || lower.includes("address")) {
                  return false;
                }
                return true;
              });
            }
            cumulativeNotes.push(...processedNotes);
          }
        }
      } catch (err) {
        console.error(`Error uploading ${currentFile.file.name}:`, err);
      }
    }

    const allFieldIds = [];
    parsedSchema.forEach(col => {
      if (col.components) {
        col.components.forEach(comp => {
          if (["textBox", "date", "dropDown", "radio", "multiLineBox", "checkBox"].includes(comp.dataType)) {
            if (comp.attributeObject) {
              allFieldIds.push(comp.attributeObject);
            }
          }
        });
      }
    });

    let targetFieldIds = allFieldIds;
    if (isAchForm || hasCheckFile || hasAchComponents) {
      const achFields = allFieldIds.filter(id => (isAchTargetField(id) || isAchTargetField(fieldMap[id])) && !isAddressField(id) && !isAddressField(fieldMap[id]));
      targetFieldIds = achFields.length > 0 ? achFields : ["yourBankName", "routing", "account"];
    }

    cumulativeUnfilledIds = targetFieldIds.filter(id => {
      const mappedId = fieldMap[id] || id;
      const val = cumulativeMappedValues[mappedId] || cumulativeMappedValues[id];

      if (!val) return true;

      if (typeof val === 'string') {
        const lowerVal = val.trim().toLowerCase();
        if (['n/a', 'none', 'null', '-', 'not specified', 'missing', 'not found'].includes(lowerVal)) {
          return true;
        }
      }

      return false;
    });

    setUpdatedStateData(prev => ({ ...(prev || {}), ...cumulativeMappedValues }));
    if (cumulativeNotes.length > 0) setAiNotes(cumulativeNotes);
    if (cumulativeUnfilledIds.length > 0) setUnfilledIds(cumulativeUnfilledIds);
    setShowSummary(true);

    setIsUploading(false);
    setShowAIUpload(false);
    setUploadedAiFiles(prev => {
      const newFiles = [...prev];
      aiFiles.forEach(f => {
        if (!newFiles.some(existing => existing.file.name === f.file.name)) {
          newFiles.push(f);
        }
      });
      return newFiles;
    });
    setAiFiles([]);
  };
  console.log("allowEdit", allowEdit)
  console.log("wfForm", wfForm)
  console.log("wfTask", wfTask)
  return (
    <div>
      {wfTask && allowEdit && wfForm && (
        <div style={{ padding: "10px 2px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            {!showAIUpload && (
              <>
                <button className="btn btn-sm" style={{ backgroundColor: "#3994FD", borderColor: "#3994FD", color: "white", fontWeight: "bold" }} onClick={() => setShowAIUpload(true)}>
                  {getUploadButtonText()}
                </button>
                <span style={{ fontSize: "14px", color: "black", marginTop: "4px", fontWeight: "bold" }}>
                  The Data will be automatically captured by AI and displayed below
                </span>
              </>
            )}
          </div>
          <div>
            {!showAIUpload && (aiNotes.length > 0 || unfilledIds.length > 0) && (
              <button className="btn btn-sm btn-outline-dark" onClick={() => setShowSummary(!showSummary)}>
                {showSummary ? "Hide Summary" : "Show Summary"}
              </button>
            )}
          </div>
        </div>
      )}

      {showAIUpload && allowEdit && wfForm && (
        <div style={{ padding: "20px" }}>
          <div
            style={{
              border: "2px dashed #cbd5e1",
              padding: "30px",
              textAlign: "center",
              backgroundColor: "#f8fafc",
              borderRadius: "8px",
              cursor: aiFiles.length >= getMaxFileLimit() ? "not-allowed" : "pointer",
              position: "relative"
            }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onClick={() => {
              if (aiFiles.length >= getMaxFileLimit()) {
                const limit = getMaxFileLimit();
                getAlert(
                  "Upload Limit Reached",
                  `You have already uploaded the maximum of ${limit} ${limit === 1 ? "document" : "documents"}. Please remove a document if you want to upload a different one.`,
                  "warning"
                );
                return;
              }
              document.getElementById("ai-file-upload").click();
            }}
          >
            <i className="fa fa-cloud-upload" style={{ fontSize: "2rem", color: "#64748b", marginBottom: "10px" }}></i>
            <p style={{ color: "#475569", marginBottom: "5px" }}>
              {aiFiles.length >= getMaxFileLimit()
                ? `Maximum limit reached (${aiFiles.length}/${getMaxFileLimit()} documents uploaded)`
                : `Click or Drag & Drop up to ${getMaxFileLimit()} ${getMaxFileLimit() === 1 ? "document" : "documents"} here (PDF, DOCX, JPG, PNG)`}
            </p>
            <input
              type="file"
              multiple
              accept=".pdf,.docx,.doc,.jpg,.jpeg,.png,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/jpeg,image/png"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="ai-file-upload"
            />
          </div>

          {aiFiles.length > 0 && (
            <div style={{ marginTop: "15px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
              {aiFiles.map((fileObj, index) => {
                const isPdf = /\.pdf$/i.test(fileObj.file.name);
                const isImg = /\.(jpe?g|png)$/i.test(fileObj.file.name);
                return (
                  <div key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", border: "1px solid #e2e8f0", borderRadius: "4px", backgroundColor: "#fff", overflow: "hidden" }}>
                    <span style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={fileObj.file.name}>
                      <i className={`fa ${isPdf ? "fa-file-pdf-o" : isImg ? "fa-file-image-o" : "fa-file-text-o"} text-primary`} style={{ marginRight: "8px" }}></i>
                      {fileObj.file.name}
                    </span>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveFile(index);
                      }}
                      disabled={isUploading}
                      style={{ padding: "2px 6px", flexShrink: 0, marginLeft: "10px" }}
                      title="Remove"
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                );
              })}
            </div>
          )}

          <div style={{ marginTop: "15px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            {(aiNotes.length > 0 || unfilledIds.length > 0) && (
              <button className="btn btn-sm" style={{ border: "1px solid #000", color: "#000", backgroundColor: "transparent" }} onClick={() => setShowSummary(!showSummary)}>
                {showSummary ? "Hide Summary" : "Show Summary"}
              </button>
            )}
            <button className="btn btn-sm" style={{ border: "1px solid #000", color: "#000", backgroundColor: "transparent" }} onClick={() => setShowAIUpload(false)} disabled={isUploading}>
              Close
            </button>
            {aiFiles.length > 0 && (
              <button className="btn btn-sm" style={{ border: "1px solid #000", color: "#000", backgroundColor: "transparent" }} onClick={handleUploadDoc} disabled={isUploading}>
                {isUploading ? "Uploading..." : "Upload"}
              </button>
            )}
          </div>
        </div>
      )}

      {(aiNotes.length > 0 || unfilledIds.length > 0) && (
        <div style={{
          backgroundColor: "#fffbeb",
          border: showSummary ? "1px solid #fde68a" : "none",
          borderLeft: showSummary ? "4px solid #f59e0b" : "none",
          marginBottom: showSummary ? "20px" : "0",
          maxHeight: showSummary ? "1000px" : "0",
          opacity: showSummary ? 1 : 0,
          overflow: "hidden",
          padding: showSummary ? "15px 20px" : "0 20px",
          transition: "all 0.4s ease-in-out"
        }}>
          <h5 style={{ color: "#b45309", fontSize: "15px", fontWeight: "600", margin: "0 0 10px 0" }}>
            <i className="fa fa-info-circle" style={{ marginRight: "6px" }}></i> AI AutoFill Summary
          </h5>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
            {aiNotes.length > 0 && (
              <div style={{ flex: "1 1 300px" }}>
                <strong style={{ fontSize: "13px", color: "#92400e", display: "block", marginBottom: "5px" }}>Notes:</strong>
                <ul style={{ margin: 0, paddingLeft: "20px", fontSize: "13px", color: "#92400e" }}>
                  {aiNotes.map((note, idx) => (
                    <li key={idx} style={{ marginBottom: "3px" }}>{cleanTalonicText(note)}</li>
                  ))}
                </ul>
              </div>
            )}
            {unfilledIds.length > 0 && (
              <div style={{ flex: "1 1 300px" }}>
                <strong style={{ fontSize: "13px", color: "#92400e", display: "block", marginBottom: "5px" }}>Unidentified Fields:</strong>
                <ul style={{ margin: 0, paddingLeft: "20px", fontSize: "13px", color: "#92400e" }}>
                  {unfilledIds.map((id, idx) => (
                    <li key={idx} style={{ marginBottom: "3px" }}>{formatUnfilledFieldLabel(id)}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}

      {wfTask?.formId > 0 && <WorkflowElement
        wfTask={wfTask}
        handleNextTask={handleNextTask}
        viewType={!allowEdit}
        appSummary={false}
        codeVerified={true}
        wfTaskType={"viewForm"}
        saveBtnProcessStatus={saveBtnProcessStatus}
        setSaveBtnProcessStatus={setSaveBtnProcessStatus}
        workflowFormData={updatedStateData}
      />}
    </div>
  );
}

export default ViewForm;
